module.exports = __webpack_public_path__ + "static/media/LY.f952e296.png";